<template>
  <div class="query-map">
    <div class="search-container" :class="{ 'collapsed': isCollapsed }">
      <a-input-search v-model="searchInfo" enter-button="搜索" @input="sustainInput" @search="handleSearch"
        placeholder="请输入关键词" class="search-input" size="large" v-show="!isCollapsed" />
      <a-button @click="handleClear" class="clear-btn" type="default" size="large" v-show="!isCollapsed">
        <a-icon type="delete" />
        清除
      </a-button>

    </div>

    <!-- 搜索结果列表 -->
    <div class="search-results-list" v-show="!isCollapsed && isShowData && searchRes && searchRes.length > 0">
      <div class="list-header">
        <span class="list-title">搜索结果 ({{ searchRes.length }})</span>
      </div>
      <div class="list-content">
        <div v-for="(item, index) in searchRes" :key="index" class="list-item" @click="handleItemClick(item, index)">
          <div class="item-content">
            <div class="item-name">{{ item.name || item.address || `结果 ${index + 1}` }}</div>
            <div class="item-address" v-if="item.address && item.name">{{ item.address }}</div>
            <div class="item-distance" v-if="item.distance">{{ item.distance }}m</div>
          </div>
          <div class="item-icon">
            <a-icon type="environment" />
          </div>
        </div>
      </div>
    </div>
    <a-button @click="toggleCollapse" class="collapse-btn" type="default" size="large">
      <a-icon :type="isCollapsed ? 'search' : 'left'" />
    </a-button>

  </div>
</template>

<script>
import storage from 'store'
import { LonLat } from '@/store/mutation-types'
export default {
  name: 'QueryMap',
  data () {
    return {
      searchInfo: '',
      isCollapsed: false,
      tianDTtk: '2217db4d2cabf0ad3f9c0d8b29a85498',
      specify: '',
      searchRes: [],
      isShowData: false,
      selectedIndex: null
    }
  },
  mounted () {
    this.initialize();
  },
  methods: {
    /**
     * 获取行政区的国标码
     */
    async initialize () {
      try {
        const location = storage.get(LonLat);
        if (!location || location.length < 2) {
          console.warn('未获取到有效的地理位置信息');
          return;
        }

        const data = {
          lon: location[0],
          lat: location[1],
          ver: 1
        };

        const params = new URLSearchParams({
          postStr: JSON.stringify(data),
          type: 'geocode',
          tk: this.tianDTtk
        });

        const response = await fetch(`https://api.tianditu.gov.cn/geocoder?${params}`);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();

        if (result.result && result.result.addressComponent) {
          this.specify = result.result.addressComponent.county_code;
          console.log('成功获取行政区代码:', this.specify);
        } else {
          console.warn('地理编码响应格式异常:', result);
        }
      } catch (error) {
        console.error('获取地理编码失败:', error);
      }
    },

    /**
     * 执行搜索
     */
    async search () {
      if (!this.searchInfo || !this.searchInfo.trim()) {
        console.warn('请输入搜索关键词');
        return;
      }

      try {
        const data = {
          yingjiType: 1,
          sourceType: 0,
          keyWord: this.searchInfo.trim(),
          mapBound: '-180,-90,180,90',
          specify: this.specify,
          level: 12,
          queryType: 1,
          start: 0,
          count: 100,
          queryTerminal: 1000,
          show: 2
        };

        const searchParams = new URLSearchParams({
          postStr: JSON.stringify(data),
          type: 'query',
          tk: this.tianDTtk
        });

        const response = await fetch(`https://api.tianditu.gov.cn/v2/search?${searchParams}`);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();

        if (result.pois && Array.isArray(result.pois)) {
          this.searchRes = result.pois;
          console.log(this.searchRes);
          this.isShowData = true;
          console.log(`找到 ${result.pois.length} 个搜索结果`);
        } else {
          this.searchRes = [];
          this.isShowData = false;
          console.log('未找到相关结果');
        }
      } catch (error) {
        console.error('搜索失败:', error);
        this.searchRes = [];
        this.isShowData = false;
      }
    },
    /**
     * 处理输入事件
     */
    sustainInput (e) {
      // const value = e.target.value;
      // console.log('输入内容:', value);
      // this.$emit('input-change', value);
    },

    /**
     * 处理搜索事件
     */
    handleSearch (value) {
      console.log('搜索:', value);
      if (value && value.trim()) {
        this.search();
      } else {
        console.warn('请输入搜索关键词');
      }
    },

    /**
     * 清除搜索内容
     */
    handleClear () {
      this.searchInfo = '';
      this.searchRes = [];
      this.isShowData = false;
      this.$emit('clear-search');
    },

    /**
     * 切换折叠状态
     */
    toggleCollapse () {
      this.isCollapsed = !this.isCollapsed;
      // this.$emit('collapse-change', this.isCollapsed);
    },

    /**
     * 处理列表项点击
     */
    handleItemClick (item, index) {
      this.searchInfo = item.name;
      this.searchRes = [];
      this.isShowData = false;
      this.selectedIndex = index;
      console.log('选择的搜索结果:', item);

      // 发射选择事件，传递完整的搜索结果数据
      this.$emit('result-selected', item);
    }
  }
}
</script>

<style lang="less" scoped>
.query-map {
  position: fixed;
  left: 0;
  top: 3%;
  z-index: 1000;
  width: 480px;
  display: flex;
  gap: 0;
  align-items: flex-start;
}

.search-container {
  display: flex;
  gap: 12px;
  align-items: center;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 12px 0 0 12px;
  padding: 12px 16px;
  box-shadow: none;
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
  margin-left: 20px;

  // &:hover {
  //   transform: translateY(-2px);
  //   box-shadow: 0 6px 25px rgba(0, 0, 0, 0.2);
  // }
}

.collapsed {
  background: none;
  padding: 0;
  border: none;
  margin-left: 0;
}

.search-input {
  flex: 1;

  /deep/ .ant-input-group-wrapper {
    width: 100%;
  }

  /deep/ .ant-input {
    border-radius: 8px 0px 0px 8px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    transition: all 0.2s ease;

    &:focus {
      border-color: #1890ff;
      box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
    }
  }

  /deep/ .ant-input-search-button {
    border-radius: 0 8px 8px 0;
    background: linear-gradient(135deg, #1890ff, #40a9ff);
    border: none;
    transition: all 0.2s ease;

    &:hover {
      background: linear-gradient(135deg, #40a9ff, #69c0ff);
      transform: translateY(-1px);
    }
  }
}

.search-results-list {
  position: absolute;
  top: 100%;
  left: 20px;
  right: 60px;
  margin-top: 8px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  max-height: 300px;
  overflow: hidden;
  z-index: 1000;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

  .list-header {
    padding: 12px 16px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
    background: rgba(24, 144, 255, 0.05);

    .list-title {
      font-size: 14px;
      font-weight: 500;
      color: #1890ff;
    }
  }

  .list-content {
    max-height: 250px;
    overflow-y: auto;

    /* 自定义滚动条 */
    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-track {
      background: rgba(0, 0, 0, 0.05);
      border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
      background: rgba(0, 0, 0, 0.2);
      border-radius: 3px;

      &:hover {
        background: rgba(0, 0, 0, 0.3);
      }
    }
  }

  .list-item {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.04);
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      background: rgba(24, 144, 255, 0.05);
    }

    &.active {
      background: rgba(24, 144, 255, 0.1);
      border-left: 3px solid #1890ff;
    }

    &:last-child {
      border-bottom: none;
    }

    .item-content {
      flex: 1;
      min-width: 0;

      .item-name {
        font-size: 14px;
        font-weight: 500;
        color: #333;
        margin-bottom: 4px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      .item-address {
        font-size: 12px;
        color: #666;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-bottom: 2px;
      }

      .item-distance {
        font-size: 11px;
        color: #999;
      }
    }

    .item-icon {
      margin-left: 12px;
      color: #1890ff;
      font-size: 16px;
      opacity: 0.7;
      transition: opacity 0.2s ease;
    }

    &:hover .item-icon {
      opacity: 1;
    }
  }
}

.clear-btn {
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  background: rgba(255, 255, 255, 0.8);
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 4px;

  &:hover {
    background: rgba(255, 77, 79, 0.1);
    border-color: #ff4d4f;
    color: #ff4d4f;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
}

.collapse-btn {
  border-radius: 0 12px 12px 0;

  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 66px;
  min-width: 40px;
  flex-shrink: 0;
  box-shadow: none;
  margin-left: -1px;

  &:hover {
    background: rgba(24, 144, 255, 0.1);
    border-color: #1890ff;
    color: #1890ff;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  .anticon {
    font-size: 16px;
    transition: transform 0.2s ease;
  }

  &:hover .anticon {
    transform: scale(1.1);
  }
}

// 响应式设计
@media (max-width: 768px) {
  .query-map {
    left: 10px;
    top: 10px;
    width: calc(100vw - 20px);
    max-width: 400px;
  }

  .search-container {
    flex-direction: column;
    gap: 8px;
    padding: 8px 12px;
  }

  .search-input {
    width: 100%;
  }

  .clear-btn {
    width: 100%;
    justify-content: center;
  }
}

// 动画效果
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.query-map {
  animation: fadeIn 0.3s ease;
}

// 搜索建议样式
/deep/ .ant-input-search {
  .ant-input {
    &::placeholder {
      color: #999;
      font-size: 14px;
    }
  }
}
</style>